import { TSettingsField, TSettingsFormData } from 'src/@types';
import { ISettings } from 'src/models/management/settings/Settings';
import { TApiResponseData } from 'src/service/apiTypes';
import instance from 'src/service/axios';
import { HEADERS_MULTIPART } from 'src/static/constants';

const SUB_URL = '/v1/companyInfo';

// API 요청을 위한 타입
export interface ISettingsRequest {
  companyInfos: Array<Omit<TSettingsField, 'logoImgPath' | 'locationImgPath' | 'companyIntroPath'>>;
}

const convertDataInfoToFormData = (data: TSettingsFormData) => {
  const formData = new FormData();
  data.companyInfos?.forEach((info, index) => {
    Object.entries(info).forEach(([key, value]) => {
      // 파일이 아닌 일반 필드들
      if (value && !['logoImgFile', 'locationImgFile', 'companyIntroFile'].includes(key)) {
        formData.append(`companyInfos[${index}].${key}`, value.toString());
      }
    });
    if (info.logoImgFile) {
      formData.append(`companyInfos[${index}].logoImgFile`, info.logoImgFile);
    }
    if (info.locationImgFile) {
      formData.append(`companyInfos[${index}].locationImgFile`, info.locationImgFile);
    }
    if (info.companyIntroFile) {
      formData.append(`companyInfos[${index}].companyIntroFile`, info.companyIntroFile);
    }
  });

  return formData;
};

/**
 * 조회
 */
export const getSettings = async () => {
  try {
    const url = SUB_URL;
    const response = await instance.get<TApiResponseData<ISettings[]>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 업데이트
 */
export const updateSettings = async (data: TSettingsFormData) => {
  try {
    const formData = convertDataInfoToFormData(data);

    const response = await instance.put<TApiResponseData<ISettings>>(
      `${SUB_URL}`,
      formData,
      HEADERS_MULTIPART,
    );

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};
